module.exports = "../../../../platform/assets/pageMainIcon/yewuchulilei2.svg";